import { callAPI } from '../network';

export async function getCompanies (){
  
    const data = await callAPI(
                         null, 
                         'Company/GetAllCompanies', 'get');
    return data || [ ];
 }


 export async function getEmployeesWithCompanies (companyId){
  
    const data = await callAPI(
                         null, 
                         `Company/GetEmployeesWithCompanies?companyId=${companyId}`, 'get');
    return data || [ ];
 }

 export async function getAllEmployeesWithCompaniesByAirport(airportId, companyId){

   const data = await callAPI(
                        null, 
                        `Company/GetAllEmployeesWithCompaniesByAirport?airportId=${airportId}&companyId=${companyId}`, 'get');
   return data;
}

export async function getAllEmployeesByAirport(airportId, companyId){

   const data = await callAPI(
                        null, 
                        `Company/GetAllEmployeesForEdit?airportId=${airportId}&companyId=${companyId}`, 'get');
   return data;
}

export async function getAllCompaniesByEmployee(employeeId){
   let data;
      data = await callAPI(
         null, 
         'Company/GetCompaniesByEmployee?employeeId='+ employeeId, 'get');
   
  
   return data || [ ];
}

export async function UpdateCompaniesByEmployee (companies, employee ){

   //console.log(airports);
   const params = {
      companies: companies.companies.map(company => ({
         Id: company.Id, // Asegúrate de usar la capitalización correcta, como aparece en el objeto.
         Code: company.Code // Igualmente aquí.
       })),
       employeeId: companies.employeeId,
       employee: employee
    };

   
   const data = await callAPI(
                  params, 
                        'Company/UpdateCompaniesByEmployee', 'post');
   return data || [ ];
}

export async function deleteCompaniesByEmployee (id, employee){
   const data = await callAPI(
                        null,
                        `Company/DeleteCompaniesByEmployee?employeeId=${id}&employee=${employee}`, 'get');
   return data;
}

export async function bulkUpdateCompaniesByEmployees(employeeIds, companies, employee) {
   const params = { employeeIds, companies, employee };
   const data = await callAPI(params, 'Company/BulkUpdateCompaniesByEmployees', 'post');
   return data;
}